import { getEvent } from 'components/graphql/queries';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import * as JSCookie from 'js-cookie';
import React from 'react';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import PrintedTicketsActivationModal from './PrintedTicketsActivationModal'

export default class PrintedTicketActivation extends React.Component<{ [label: string]: any }, { [label: string]: any }> {
    public state = {
        event: {},
        loading: true
    };

    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        fetchGraphQL(
            getEvent(this.props.eventId), JSCookie.get("token")
        ).then(result => {
            if (result !== undefined && result.event !== undefined && result.event.get !== undefined) {
                this.setState({ event: result.event.get, loading: false })
            }
        })
    }

    public handleOpenCreateModal(single: boolean) {
        const content = (
            <PrintedTicketsActivationModal
                onClose={() => closeModal()}
                eventId={this.props.eventId}
                event={this.state.event}
                changeMade={() => this.props.changeMade()}
                single={single}
            />
        );
        openModal(content, "Program Isotope Printed Tickets", []);
    }
    public render() {
        return (
            <div style={{ height: 'auto', width: '100%', textAlign: 'center' }}>
                <hr />
                {
                    this.state.loading ? null :
                        <div>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <h4 className="sexyBlack" style={{ paddingTop: '25px' }}>
                                    Sell Printed Tickets
                                </h4>
                                <p />
                            </div>
                            <div style={{ width: '100%' }}>
                                <button
                                    className='new-button-blue-gradient'
                                    onClick={e =>
                                        this.handleOpenCreateModal(false)
                                    }
                                    style={{
                                        border: 'none'
                                    }}
                                >
                                    Begin
                                </button>
                            </div>
                            <p>
                                <br />
                            </p>
                        </div>
                }
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/manage/tickets/activate/digital/PrintedTicketActivation.tsx